// Admin authentication API (PLA-86).
//
// POST /api/admin/auth/login  { email, password }
//   → { access, refresh, admin: { id, email, full_name, is_superadmin,
//        institution: { id, name } } }
// POST /api/admin/auth/refresh { refresh } → { access }  (handled by the
//   axios response interceptor in client.ts, not here).

import { apiClient } from "./client"

import type { AdminUser } from "@/types"

export interface AdminLoginResponse {
  access: string
  refresh: string
  admin: AdminUser
}

export const adminAuthApi = {
  login: (email: string, password: string) =>
    apiClient
      .post<AdminLoginResponse>("/admin/auth/login", { email, password })
      .then((r) => r.data),
}
